module.exports = __webpack_public_path__ + "img/help-icon1.51c0280a.png";